/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coinvestments_Messages_Markreaderror3Inputs */

const en_coinvestments_messages_markreaderror3 = /** @type {(inputs: Coinvestments_Messages_Markreaderror3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Failed to mark conversation as read. Please try again.`)
};

/**
* | output |
* | --- |
* | "Failed to mark conversation as read. Please try again." |
*
* @param {Coinvestments_Messages_Markreaderror3Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const coinvestments_messages_markreaderror3 = /** @type {((inputs?: Coinvestments_Messages_Markreaderror3Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coinvestments_Messages_Markreaderror3Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_coinvestments_messages_markreaderror3(inputs)
});
export { coinvestments_messages_markreaderror3 as "coInvestments_messages_markReadError" }